import { render, staticRenderFns } from "./SiderRouteEditorText.vue?vue&type=template&id=1858d633&scoped=true&"
import script from "./SiderRouteEditorText.vue?vue&type=script&lang=js&"
export * from "./SiderRouteEditorText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858d633",
  null
  
)

export default component.exports